import { render, staticRenderFns } from "./AffiliateHelpPage.vue?vue&type=template&id=524ffcbb&scoped=true&"
import script from "./AffiliateHelpPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateHelpPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateHelpPage.vue?vue&type=style&index=0&id=524ffcbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ffcbb",
  null
  
)

export default component.exports